
export default {
  mapForm: {
    placesAndDirections: 'Find & go',
    isochrones: 'Reach',
    uploadedContentRendered: 'Uploaded content rendered',
    errorRenderingContentUploaded: 'Error while rendering the content uploaded. Check the file format and content'
  }
}
